import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import RouteConstant from "navigation/constant";
import MainContainer from "parts/mainContainer";
import React from "react";
import { Link } from "react-router-dom";

const PhoneBookingUnavailable: React.FC = () => {
  return (
    <section>
      <MainContainer>
        <Box
          py={{ xs: 6, md: 10 }}
          textAlign="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Typography fontSize={{ xs: 26, md: 40 }} fontWeight={700}>
            Phone booking is temporarily unavailable
          </Typography>
          <Typography maxWidth={620} color="text.secondary">
            We are making improvements to this flow right now. Please try again
            later or continue exploring our available plans.
          </Typography>
          <Box pt={1} display="flex" gap={2} flexWrap="wrap" justifyContent="center">
            <Link to={RouteConstant.PRODUCTS}>
              <Button variant="contained" color="primary">
                Explore Products
              </Button>
            </Link>
            <Link to={RouteConstant.HOME}>
              <Button variant="outlined" color="primary">
                Go to Home
              </Button>
            </Link>
          </Box>
        </Box>
      </MainContainer>
    </section>
  );
};

export default PhoneBookingUnavailable;
